export const HEATMAP_REQUIRED_METRIC = "channel_budget" as const;

export const HEATMAP_DEFAULT_SELECTED_METRICS = [HEATMAP_REQUIRED_METRIC, "impressions", "cpm"] as const;

export const HEATMAP_BASE_METRIC_SUFFIXES = ["budget", "impressions", "cpm"] as const;
